import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { ProjectService } from '../services/project.service';

export const authGuard: CanActivateFn = async (route, state) => {
    const serv = inject(ProjectService);
    const router = inject(Router);
    const applist = await lastValueFrom(serv.getAllProjects());
    if (applist.projects.length < 1) {
        return true;
    } else {
        router.navigate(['workspace/apps']);
        return false;
    }
};
